import {SET_MESSAGE, EMPTY_MESSAGE} from "@/store/mutation-types"

export default {
	methods: {
		setLoadingMessage() {
			if (!this.isSuccessMessage()) {
				this.setInfoMessage(this.$gettext('Načítání…'))
			}
		},
		setInfoMessage(message) {
			this.setMessage(message, 'info')
		},
		setInfoMessageWithTimeout(message, timeout = 3000) {
			this.setInfoMessage(message)
			setTimeout(function () {
				this.emptyMessage(true)
			}.bind(this), timeout)
		},
		setErrorMessage(message, timeout = 3000) {
			if (message === 'Byl jste odhlášen.' || message === 'Invalid login information') {
				this.$router.push({name: 'login'})
			} else {
                console.log(message);
				this.setMessage(message, 'error')
				setTimeout(function () {
					this.emptyMessage(true)
				}.bind(this), timeout)
			}
		},
		isSuccessMessage() {
			return this.$store.getters.getVariant === 'success'
		},
		setSuccessMessage(message = null, timeout = 3000) {
			if (message === null) {
				message = this.$gettext('Uloženo')
			}
			this.setMessage(message, 'success')
			setTimeout(function () {
				this.emptyMessage(true)
			}.bind(this), timeout)
		},
		setMessage(message, variant) {
			this.$store.commit(SET_MESSAGE, {message: message, variant: variant})
		},
		emptyMessage(success = false) {
			if (!this.isSuccessMessage() || success) {
				this.$store.commit(EMPTY_MESSAGE)
			}
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/message.js